import { request } from "../../api/api"
import { downloadFile } from "../../utils/utils";

export const jobProviderList = (page = 1, pageSize = 10, apiStatus = null) => {
    const params = new URLSearchParams({
        page,
        page_size: pageSize,
    });
    if (apiStatus && apiStatus !== 'All') {
        params.append('api_status', apiStatus);
    }
    return request.get(`/job-provider-list/?${params.toString()}`);
}
export const jobProviderUpdate =(data)=>{
    return request.put("/job-provider-update-action/",data)
}
export const dashboardCounts =()=>{
    return request.get("/admin-panel-dashboard-counts")
}
export const userGrowthGraph =()=>{
    return request.get("/user-growth-graph/")
}
export const getJobProviderPerformance =()=>{
    return request.get("/job-provider-performance/")
}
export const adminDashboardReportExport =()=>{
    return downloadFile("/admin-dashboard-report-export/", "GET");
}
export const apiLogsExportReport =()=>{
    return downloadFile("/api-logs-export-report/", "GET");
}